import BaseModel from './BaseModel'

export default class RepairModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            type: ['typeName', undefined, value => value],
            description: ['description', undefined, value => value],
            stationIds: ['stationIds', undefined, value => value],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
        type: 'Тип ремонта',
        stationIds: 'СТО',
    }
}
